export default __webpack_public_path__ + "static/7-d84411d0d98df7e74ef94b4cb269fea8.png";